// src/app/slices/louverSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deleteAccessory } from './actions';
import { ILouver, ILouverParams, AccessoryState } from '../models';

const initialState: AccessoryState<ILouver, ILouverParams> = {
  accessories: {},
  params: null,
};

const louverSlice = createSlice({
  name: 'louver',
  initialState,
  reducers: {
    setLouver: (state, action: PayloadAction<ILouver>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setLouverParams: (state, action: PayloadAction<ILouverParams>) => {
      state.params = action.payload;
    },
    deleteLouver: deleteAccessory,
  },
});

export const { setLouver, setLouverParams, deleteLouver } = louverSlice.actions;

export default louverSlice.reducer;
